import * as yup from "yup";
import { Constants } from "../../helpers/Constants";
import { ComplianceOptions } from "./Home/ApplicationDetails.types";

export type UserFormProps = {
  id: string;
  returnPath: string;
  title: string;
  //applicationInspectionId?: number;
  //applicationId?: number;
  values?: UserInput;
  action: "post" | "put";
};


export type UserInput = {
  userSecurityId:number;
  userClaimsObjectId:string;
  roleId:Number;
  userName:string;
  lastName:string;
  firstName:string;
  middleName:string;
  email:string;
  phone: string;
  address: string;
  city: string;
  zipCode: string;
  stateId: number;
  countyId: number;
  isActive: boolean;
  lastLoginDate: Date;
  isDeleted: boolean;
  jobTitle: string;
  jobDescription: string;
  createdby: string;
  updatedby: string;
  userStatus: string;
  dateCreated: Date | string;
  dateUpdated:Date | string;
  updatedBy: string;
};


export const schema = yup.object().shape({

    userClaimsObjectId: yup.string()
                .required("user ObjectId is required")
                .typeError("user ObjectId is required"),
        
                email: yup.string()
                .required("Email is required")
                .typeError("Email is required"),

                firstName: yup.string()
                .required("First Name is required")
                .typeError("First Name is required"),
        
                lastName: yup.string()
                .required("Last Name is required")
                .typeError("Last Name is required"),
        
                userName: yup.string()
                .required("UserName is required")
                .typeError("UserName is required"),
        
        

        //         isActive: yup
        // .number()
        // //.min(1, "isActive flag is required")
        // .required("isActive flag is required")
        // .typeError("isActive flag is required"),

        // roleId: yup
        // .number()
        // //.min(1, "isActive flag is required")
        // .required("Role is required")
        // .typeError("Role is required"),



});
/*=======================================================================================*/

